import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-757623af"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "blog-main blog-container" }
const _hoisted_2 = { class: "blog" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" While not essential, "),
  /*#__PURE__*/_createElementVNode("span", { class: "highlight-text" }, "smooth scrolling"),
  /*#__PURE__*/_createTextVNode(" is a delightful feature to enhance the user experience on web pages with internal links. This web page utilizes smooth scrolling to provide a seamless navigation experience. Traditionally, implementing smooth scrolling involves using jQuery, which requires importing the jQuery plugin, setting up jQuery classes, writing JavaScript functions for those classes, and applying them to HTML links. While this approach works well, there is a simpler alternative called react-scroll. React-scroll offers a straightforward solution without the need for jQuery, making the implementation process much simpler and more streamlined. ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" First, install "),
  /*#__PURE__*/_createElementVNode("span", { class: "highlight-text" }, "react-scroll"),
  /*#__PURE__*/_createTextVNode(". Go to your terminal and run this command. ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Next import the "),
  /*#__PURE__*/_createElementVNode("span", { class: "highlight-text" }, "react-scroll"),
  /*#__PURE__*/_createTextVNode(" package. Put the following code at the top of the react JS file. ")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Instead of using an anchor tag, use a react Link Component.", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Set the to property to the ID of the element you want to link to. That's all it takes to implement smooth scrolling in react. ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Even something as seemingly simple as centering an item can sometimes be frustrating. However, there are a few straightforward ways to achieve it. If the parent element has its display property set to grid, you can easily center an item by applying the appropriate grid properties. Let me show you how. ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "In CSS grid, centering grid items can be done in one line.", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Let me provide you with an example to illustrate how it works. I have created a 3D cube, which is contained within a parent element highlighted by a salmon-colored border. The parent element has a class named '.square', while the cube itself has a class named '.cube'. First, I will show you the CSS code, followed by the cube's appearance before applying the 'place-items' property. ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Now lets add the place-items property to center the cube.", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Let's explore the concept of flexbox. By default, the 'flex-direction' property is set to 'row'. To center flex items in a row, we need to set two properties: 'align-items' and 'justify-content'. Setting both of these properties to 'center' achieves vertical and horizontal centering respectively. Below, you'll find a flex container with three circles (flex items) inside it. Clicking the button below will apply the two properties to the container, resulting in centered alignment. ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":""} }, "!!! CENTER ME !!!", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " If the 'flex-direction' property is set to 'column', the centering properties work differently. To horizontally center the flex items, you need to set the 'justify-items' property to 'center'. On the other hand, to vertically center the items, you should set the 'align-content' property to 'center'. It can be confusing because these four properties have similar names, but their functionality differs depending on the flex direction. ", -1))

import { ref } from 'vue'
  import BlogImage from './utilities/BlogImage.vue'
  import CodeSnippet from './utilities/CodeSnippet.vue'
  import Credit from './Credit.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BlogTwo',
  setup(__props) {

  const toggleExample = ref(false)

  const part1 = ref<HTMLElement | null>(null)
  const part2 = ref<HTMLElement | null>(null)

  function exampleToggle() {
    toggleExample.value = !toggleExample.value
  }

  function scrollPart1() {
    part1.value?.scrollIntoView({ behavior: 'smooth' })
  }
  function scrollPart2() {
    part2.value?.scrollIntoView({ behavior: 'smooth' })
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", { class: "blog-links mb-4 d-flex" }, [
        _createElementVNode("span", {
          onClick: scrollPart1,
          class: "mx-1"
        }, "Smooth Scrolling React"),
        _createElementVNode("span", {
          onClick: scrollPart2,
          class: "mx-1"
        }, "Centering A Div")
      ]),
      _createElementVNode("h2", {
        ref_key: "part1",
        ref: part1
      }, "Smooth Scrolling React", 512),
      _hoisted_3,
      _hoisted_4,
      _createVNode(CodeSnippet, {
        lang: "",
        code: "npm i -S react-scroll"
      }),
      _hoisted_5,
      _createVNode(CodeSnippet, {
        lang: "js",
        code: "import { Link, animateScroll as scroll } from 'react-scroll';"
      }),
      _hoisted_6,
      _createVNode(CodeSnippet, {
        lang: "js",
        code: "<Link\nactiveClass='active'\nto='link-1'\nspy={true}\nsmooth={true}\noffset={-70}\nduration={500}\n>\nThis is the link\n</Link>"
      }),
      _hoisted_7,
      _createElementVNode("h2", {
        ref_key: "part2",
        ref: part2
      }, "Centering A Div", 512),
      _hoisted_8,
      _hoisted_9,
      _createVNode(CodeSnippet, {
        lang: "css",
        code: "place-items: center;"
      }),
      _hoisted_10,
      _createVNode(CodeSnippet, {
        lang: "css",
        code: ".square {\nwidth: 30rem;\nheight: 30rem;\nborder: 1px solid salmon;\ndisplay: grid;\n}\n.cube {\nwidth: 20rem;\nheight: 20rem;\ncolor: #FFF\n}"
      }),
      _createVNode(BlogImage, { url: "https://github.com/erictarter/my-blog/blob/main/src/img/Screen%20Shot%202020-12-11%20at%2010.58.36%20AM.png?raw=true" }),
      _hoisted_11,
      _createVNode(CodeSnippet, {
        lang: "css",
        code: ".square {\nwidth: 30rem;\nheight: 30rem;\nborder: 1px solid salmon;\ndisplay: grid;\nplace-items: center; <====\n}"
      }),
      _createVNode(BlogImage, { url: "https://github.com/erictarter/my-blog/blob/main/src/img/Screen%20Shot%202020-12-11%20at%2010.59.13%20AM.png?raw=true" }),
      _hoisted_12,
      (!toggleExample.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: exampleToggle
          }, "Center"))
        : _createCommentVNode("", true),
      (toggleExample.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: exampleToggle
          }, "Undo"))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(
          toggleExample.value
            ? 'example d-flex align-items-center justify-content-center mt-3'
            : 'example d-flex mt-3'
        )
      }, _hoisted_14, 2),
      _hoisted_15
    ]),
    _createVNode(Credit)
  ]))
}
}

})